import React, {useState} from 'react';
import {Card, Classes} from "@blueprintjs/core";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";

import {FilePicker} from "./FilePicker";
import {StpFileStatus} from "./StpFileStatus";
import {ViewerCanvas} from "./viewer/ViewerCanvas";

import "./App.scss";

const App: React.FC = () => {

  const [darkMode, setDarkMode] = useState(true);

  const [file, setFile] = useState<File>();

  const [stlUrl, setStlUrl] = useState<string>();

  return <div className={'layout-container'}>
    <Card className={`sidebar ${darkMode ? Classes.DARK : ''}`}>
      {file ? <StpFileStatus
        file={file}
        view={setStlUrl}
        activeStlUrl={stlUrl}
        reset={() => setFile(undefined)}
      /> : <FilePicker
        accept={'.stp'}
        onPick={setFile}
        icon={'cube'}
      >
        Select .STP file
      </FilePicker>}
    </Card>
    <div className={'canvas-wrapper'}>
      <ViewerCanvas className={'viewer-canvas'} url={stlUrl}/>
    </div>
  </div>;
};

export default App;
